@defer {
  @if (content() === 'all' && categoryService.ofCurrentCenter().length) {
    <div class="layout border-t border-gray-200 py-2">
      <div class="bg-white flex gap-4 items-center overflow-x-scroll scrollbar-hide relative">
        <div (click)="scrollLeft()"
             (keyup.enter)="emulateClick($event)"
             [class.hover:border-bleuCaliceo-300]="!giftMode()"
             [class.hover:border-vertCaliceo-100]="giftMode()"
             [class.hover:stroke-bleuCaliceo-300]="!giftMode()"
             [class.hover:stroke-vertCaliceo-100]="giftMode()"
             class="p-1 rounded-full border border-gray-300 stroke-gray-300 hidden md:block cursor-pointer"
             tabindex="0">
          <svg aria-hidden="true"
               class="w-4 h-4"
               focusable="false" role="presentation"
               style="display: block; fill: none; stroke-width: 5.33333; overflow: visible;"
               viewBox="0 0 32 32"
               xmlns="http://www.w3.org/2000/svg">
            <path d="M20 28 8.7 16.7a1 1 0 0 1 0-1.4L20 4" fill="none"></path>
          </svg>
        </div>

        <div #scrollContainer
             class="bg-white flex gap-2 items-center overflow-x-scroll scrollbar-hide relative scroll-smooth">

          @for (c of categoryService.ofCurrentCenter(); track c.id) {
            <button (click)="switchCategory(c)"
                    (keyup.enter)="emulateClick($event)"
                    [ngClass]="{
  'bg-bleuCaliceo-300': c.id === category()?.id && !giftMode(),
  'bg-vertCaliceo-100': c.id === category()?.id && giftMode()
}"
                    class="flex flex-col items-center p-4 rounded aspect-square">
              <img [ngSrc]="categoryIcon(c)" alt="" class="w-8 h-8 md:h-10 md:w-10"
                   height="64" width="64">
              <span [class.text-bleuCaliceo-300]="!giftMode()"
                    [class.text-vertCaliceo-100]="giftMode()"
                    [ngClass]="{'text-white': c.id === category()?.id}"
                    class="text-sm md:text-md mt-2 whitespace-nowrap">{{ 'category/' + c.id + '/name' | translate }}</span>
            </button>
          }
        </div>
        <div (click)="scrollRight()"
             (keyup.enter)="emulateClick($event)"
             [class.hover:border-bleuCaliceo-300]="!giftMode()"
             [class.hover:border-vertCaliceo-100]="giftMode()"
             [class.hover:stroke-bleuCaliceo-300]="!giftMode()"
             [class.hover:stroke-vertCaliceo-100]="giftMode()"
             class="p-1 rounded-full border border-gray-300 stroke-gray-300 hidden md:block cursor-pointer"
             tabindex="0">
          <svg aria-hidden="true" class="w-4 h-4" focusable="false" role="presentation"
               style="display: block; fill: none;stroke-width: 5.33333; overflow: visible;"
               viewBox="0 0 32 32">
            <path d="m12 4 11.3 11.3a1 1 0 0 1 0 1.4L12 28" fill="none"></path>
          </svg>
        </div>


      </div>
    </div>
  }

  <div [class.bg-bleuCaliceo-300]="!giftMode()"
       [class.bg-opacity-10]="content() === 'all' || content() === 'minimal'"
       [class.bg-vertCaliceo-100]="giftMode()"
       [class.h-full]="content() !== 'all' && content() !== 'minimal'">
    <div class="layout py-16 lg:pt-24">
      @if (content() === 'all' || content() === 'minimal') {
        <h2 [class.text-bleuCaliceo-300]="!giftMode()" [class.text-vertCaliceo-100]="giftMode()"
            [innerHtml]="title() | translate : { center: center()!.name } | byPass"
            class="font-semibold text-3xl leading-tight mb-8"></h2>
        @if (!center()?.enabled && !authService.user()?.admin) {
          <h1 class="text-6xl font-bold text-bleuCaliceo-300 mt-16">{{ 'comingSoon' | translate }}</h1>
        } @else {
          <div class="flex gap-6 mt-10 items-start">
            <div class="flex gap-2 md:gap-6 overflow-x-auto scrollbar-hide items-start">
              <button
                (click)="switchUniverse(null)"
                (keyup.enter)="emulateClick($event)"
                [class.bg-bleuCaliceo-300]="!giftMode()"
                [class.bg-vertCaliceo-100]="giftMode()"
                class="group relative flex-[0_0_45%] md:flex-auto min-w-48 py-2 c overflow-hidden rounded-lg text-lg">
                <div
                  [ngClass]="{'w-full': !universe() && !promo()}"
                  class="absolute inset-0 w-0 transition-all duration-[350ms] ease-out bg-white group-hover:w-full"></div>
                <span
                  [ngClass]="{
                    'text-white': !(!universe() && !promo()),
                    'text-vertCaliceo-100': !universe() && !promo() && giftMode(),
                    'text-bleuCaliceo-300': !universe() && !promo() && !giftMode(),
                    'group-hover:text-vertCaliceo-100': giftMode(),
                    'group-hover:text-bleuCaliceo-300': !giftMode()
                    }"
                  class="relative uppercase font-medium text-sm md:text-base">{{ 'all' | translate }}</span>
              </button>
              <button
                (click)="togglePromo()"
                (keyup.enter)="emulateClick($event)"
                class="group relative min-w-56 py-2 px-2 md:px-8 overflow-hidden rounded-lg bg-vertCaliceo-500 text-lg flex-[0_0_45%] md:flex-auto">
                <div
                  [ngClass]="{'w-full': promo()}"
                  class="absolute inset-0 w-0 transition-all duration-[350ms] ease-out group-hover:w-full bg-vertCaliceo-100"
                ></div>
                <span
                  class="relative text-white uppercase font-medium text-sm md:text-base whitespace-nowrap">{{ 'promotion' | translate }}</span>
              </button>
              @for (u of universeService.universes(); track u.id) {
                <button
                  (click)="switchUniverse(u)"
                  (keyup.enter)="emulateClick($event)" [class.bg-bleuCaliceo-300]="!giftMode()"
                  [class.bg-vertCaliceo-100]="giftMode()"
                  [ngClass]="{'pb-5 rounded-b-none': universe()?.id === u.id}"
                  class="group relative min-w-48 py-2 px-2 md:px-8 overflow-hidden rounded-lg text-lg flex-[0_0_45%] md:flex-auto">
                  <div
                    [ngClass]="{'w-full': universe()?.id === u.id}"
                    class="absolute inset-0 w-0 transition-all duration-[350ms] ease-out bg-white group-hover:w-full"></div>
                  <span
                    [ngClass]="{
                    'text-white': universe()?.id !== u.id,
                    'text-vertCaliceo-100': universe()?.id === u.id && giftMode(),
                    'text-bleuCaliceo-300': universe()?.id === u.id && !giftMode(),
                    'group-hover:text-vertCaliceo-100': giftMode(),
                    'group-hover:text-bleuCaliceo-300': !giftMode()
                    }"
                    class="relative uppercase font-medium text-sm md:text-base">{{ 'universe/' + u.id + '/name' | translate }}</span>
                </button>
              }
            </div>
            <div appAutoClose="always" class="relative inline-block text-left">
              <button>
                @if (giftMode()) {
                  <img alt="" class="w-8" height="32" ngSrc="assets/icons/green/filter.svg" width="32">
                } @else {
                  <img alt="" class="w-8" height="32" ngSrc="assets/icons/blue/filter.svg" width="32">
                }
                <span class="sr-only">Sort</span>
              </button>
              <ul
                aria-labelledby="menu-button"
                aria-orientation="vertical"
                class="py-3 absolute right-0 z-10 mt-2 w-64 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                role="menu" tabindex="0">
                <li
                  (click)="switchSort('inc')"
                  (keyup.enter)="emulateClick($event)"
                  [class.hover:bg-bleuCaliceo-300]="!giftMode()"
                  [class.hover:bg-vertCaliceo-100]="giftMode()"
                  [ngClass]="sort() === 'inc' ? 'bg-gray-100 text-gray-900' : 'text-gray-700'"
                  class="flex items-center gap-6 px-8 py-2 text-sm hover:bg-opacity-10"
                  role="menuitem" tabindex="0">
                  <div class="w-8">
                    @if (giftMode()) {
                      <img alt="" class="w-3 mx-auto" height="32" ngSrc="assets/icons/green/increasing.svg"
                           width="32">
                    } @else {
                      <img alt="" class="w-3 mx-auto" height="32" ngSrc="assets/icons/blue/increasing.svg"
                           width="32">
                    }
                  </div>
                  {{ 'increasingPrices' | translate }}
                </li>
                <li
                  (click)="switchSort('dec')"
                  (keyup.enter)="emulateClick($event)"
                  [class.hover:bg-bleuCaliceo-300]="!giftMode()"
                  [class.hover:bg-vertCaliceo-100]="giftMode()"
                  [ngClass]="sort() === 'dec' ? 'bg-gray-100 text-gray-900' : 'text-gray-700'"
                  class="text-gray-700 flex items-center gap-6 px-8 py-2 text-sm hover:bg-opacity-10"
                  role="menuitem" tabindex="0">
                  <div class="w-8">
                    @if (giftMode()) {
                      <img alt="" class="w-3 mx-auto" height="32" ngSrc="assets/icons/green/decreasing.svg" width="32">
                    } @else {
                      <img alt="" class="w-3 mx-auto" height="32" ngSrc="assets/icons/blue/decreasing.svg" width="32">

                    }
                  </div>
                  {{ 'decreasingPrices' | translate }}
                </li>
                <!--
                <li
                  (click)="filter.set('promo')"
                  (keyup.enter)="emulateClick($event)"
                  [ngClass]="filter() === 'promo' ? 'bg-gray-100 text-gray-900' : 'text-gray-700'"
                  class="text-gray-700 flex items-center gap-6 px-8 py-2 text-sm hover:bg-bleuCaliceo-300 hover:bg-opacity-10"
                  role="menuitem" tabindex="0">
                  <img alt="" class="w-8" width="32" height="32" ngSrc="assets/icons/blue/gift.svg">
                  {{ 'giftVouchers' | translate }}
                </li>
                -->
              </ul>
            </div>
          </div>

          @if (universe(); as universe) {
            <div
              class="bg-white rounded-lg flex gap-4 md:gap-2 flex-col md:flex-row px-3 md:px-5 py-3 overflow-x-auto md:-mr-5 scrollbar-hide">
              @for (a of universe.getActivities(siteService.center()?.erpId); track a) {
                <button
                  (click)="switchActivity(a)"
                  (keyup.enter)="emulateClick($event)"
                  [class.hover:bg-bleuCaliceo-300]="!giftMode()"
                  [class.hover:bg-vertCaliceo-100]="giftMode()"
                  [class.text-bleuCaliceo-300]="!giftMode()"
                  [class.text-vertCaliceo-100]="giftMode()"
                  [ngClass]="{
    '!bg-bleuCaliceo-300': a.id === activity()?.id && !giftMode(),
    '!bg-vertCaliceo-100': a.id === activity()?.id && giftMode()
  }"
                  class="flex gap-2 items-center hover:bg-opacity-10 px-4 py-2 rounded-lg group cursor-pointer">
                  <img [ngSrc]="activityIcon(a)" alt="" class="w-10" height="32" width="32">
                  <p [class.group-hover:text-bleuCaliceo-300]="!giftMode()"
                     [class.group-hover:text-vertCaliceo-100]="giftMode()"
                     [class.text-bleuCaliceo-300]="!giftMode()"
                     [class.text-vertCaliceo-100]="giftMode()"
                     [ngClass]="{'!text-white': a.id === activity()?.id}"

                     class="uppercase font-semibold whitespace-nowrap item text-left">
                    {{ 'universe/' + universe.id + '/activity/' + a.id + '/name' | translate }}
                  </p>
                </button>
              }
            </div>
          }
        }

      }
      @if (content() !== 'all' && content() !== 'minimal') {
        <h2 class="text-xl text-white font-semibold -mb-12">{{ 'selectVariant' | translate }}</h2>
      }
      <div class="grid md:grid-cols-2 lg:grid-cols-3 auto-rows-fr gap-x-4 gap-y-8 mt-16">
        @for (product of products(); track product.id) {
          <app-product-card [gift]="giftMode()" [product]="product" [redirectUrl]="redirectUrl()"></app-product-card>
        }
      </div>

      @if (content() === 'minimal') {
        <div class="grid md:grid-cols-3 gap-x-4 mt-10">
          @if (!giftMode()) {
            <a [routerLink]="['/offers']"
               appHoverGradient
               class="big-btn py-4 text-md lg:col-start-2 col-span-3 lg:col-span-1 flex justify-center items-center gap-2">
              <svg class="w-6 h-6" fill="none" stroke="white" stroke-width="1.5" viewBox="0 0 24 24"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
                  stroke-linecap="round"
                  stroke-linejoin="round"/>
              </svg>

              {{ 'showMore' | translate }}
            </a>
          } @else {
            <a [routerLink]="['/offers']"
               appHoverGradientGreen
               class="big-btn py-4 text-md col-start-2 flex justify-center items-center gap-2 bg-vertCaliceo-100">
              <svg class="w-6 h-6" fill="none" stroke="white" stroke-width="1.5" viewBox="0 0 24 24"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
                  stroke-linecap="round"
                  stroke-linejoin="round"/>
              </svg>

              {{ 'showMore' | translate }}
            </a>
          }
        </div>
      }
    </div>
  </div>
}
